export default "__VITE_ASSET__339db03b__"